import { useEffect, useState } from "react";
import GetIcon from "../../../../utils/Icon";
import GeneralDetails from "./GeneralDetails";
import TaxDetails from "./TaxDetails";
import RegistrationDetails from "./RegistrationDetails";
import printerimg from "../../../../assets/print.png";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Button from "../../../../Core/Button/Button";
import FormLayout from "../../../../Core/Layout/FormLayout";
import { usePostCreateCompanyMutation } from "../../../../store/api/companyapi";
import { useLocation, useNavigate } from "react-router-dom";
import { useGetPurchaseOrderByNameMutation } from "../../../../store/api/purchaseorderapi";
import ActivityCard from "../../../../Core/Activity/ActivityCard";
import Attachment from "../../../../utils/Attachment";
const CompanyForm = () => {
  const nvg = useNavigate();
  const location = useLocation()
  const id =location?.state.companyid 
  // console.log("check localtion",location);
  const [activeTab, setActiveTab] = useState(1);
  const [CreateCompany] = usePostCreateCompanyMutation();
  const [isSubmitting, setIsSubmitting] = useState(false); 
  const [formData, setFormData] = useState({
    companyName: '',
    abbreviation: '',
    defaultCurrency: '',
    country: '',
    defaultGSTRate: '',
    defaultHolidayList: '',
    defaultLetterHead: '',
    domain: '',
    taxID: '',
    dateOfEstablishment: '',
    parentCompany: '',
    gstinUin: '',
    pan: '',
    gstCategory: '',
    registrationDetails: '',
    isgroup: false,
  });


  const [getDocByName] = useGetPurchaseOrderByNameMutation();

 useEffect(() => {
  const getData = async () => {
    try {
      const response = await getDocByName({ doctype: 'Company', name: location.state.companyid });
      const apiData = response.data.message;
    
      const mappedData = {
        companyName: apiData.company_name || '',
        abbreviation: apiData.abbr || '',
        defaultCurrency: apiData.default_currency || '',
        country: apiData.country || '',
        defaultGSTRate: apiData.default_gst_rate || '',
        defaultHolidayList: apiData.default_holiday_list || '',
        defaultLetterHead: apiData.default_letter_head || '',
        domain: apiData.domain || '',
        taxID: apiData.tax_id || '',
        dateOfEstablishment: apiData.date_of_establishment || '',
        parentCompany: apiData.parent_company || '',
        gstinUin: apiData.gstin || '',
        pan: apiData.pan || '',
        gstCategory: apiData.gst_category || '',
        registrationDetails: apiData.registration_details || '',
        isgroup: Boolean(apiData.is_group) || false,
      };

      setFormData(mappedData);
    } catch (error) {
      console.error("Error fetching company data:", error);
    }
  };

  if (location.state?.companyid) {
    getData();
  }
}, [location.state?.companyid]);

  const [fieldErrors, setFieldErrors] = useState({
    companyName: false,
  });

  const [apiResponse, setApiResponse] = useState({
    show: false,
    type: 'error',
    message: ''
  });

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    
    if (fieldErrors[field]) {
      setFieldErrors(prev => ({
        ...prev,
        [field]: false
      }));
    }
  };



  return (
    <>
      {/* Full-page loader overlay */}
      {isSubmitting && (
        <div className="loader-overlay">
          <div className="loader-spinner">
            <div className="spinner-border" style={{color:'#270b79'}} role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      )}

      <FormLayout
        title="View Company"
        breadcrumbs={[
          { label: "Company" },
          { label: "Company List", url: "/master/company/company-list" }
        ]}
        status={'hide'}
        actionButtons={
          <>
            <Button 
              to="/" 
              className="px-2"
              imgSrc={printerimg}
              imgStyle={{ width: '21px' }}
            />
          </>
        }
      >
        <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff",flexGrow:'1' }}>
          <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
            <div className="d-flex justify-content-between align-items-end">
              <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
                <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                  <a 
                    className={activeTab === 1 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} 
                    onClick={() => setActiveTab(1)}
                  >
                    General Details{activeTab === 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                  </a>
                </li>
              </ul>

               <Attachment doctype="Company"  docname={id}  /> 

            </div>
          </div>

          <div className="mt-2 py-2" style={{ width: "100%", backgroundColor: "#fff" }}>
            <div className="col-12">
              <div className="sidebarbox m-0 px-4 py-2">
                <GeneralDetails 
                  formData={formData} 
                  handleChange={handleInputChange} 
                  errors={fieldErrors} 
                />
                <TaxDetails 
                  formData={formData} 
                  handleChange={handleInputChange} 
                  errors={fieldErrors} 
                />
                <RegistrationDetails
                  formData={formData} 
                  handleChange={handleInputChange} 
                  errors={fieldErrors} 
                />
              </div>
                 <div className="px-4 ">
                <ActivityCard doctype="Company" docname={id} />
            </div>
                    

            </div>
            
          </div>
        </div>

        <ApiResponseBox
          poptype={apiResponse.type}
          show={apiResponse.show}
          errorMessage={apiResponse.message}
          onClose={() => setApiResponse(prev => ({...prev, show: false}))}
        />
      </FormLayout>
   
    </>
  );
};

export default CompanyForm;